module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading,
      "color": "#093937"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    attrs: {
      "id": "detail-checkout"
    }
  }, [_c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "d-flex justify-content-start flex-wrap container",
    attrs: {
      "id": "checkout-page"
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-8 pt-40"
  }, [_c('div', {
    attrs: {
      "id": "booking-confirmation"
    }
  }, [_c('div', {
    staticClass: "confirmation"
  }, [_c('p', {
    staticClass: "conf-title"
  }, [_vm._v(_vm._s(_vm.$t('booking_engine.res_confirmed')))]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('booking_engine.confirmation_message')))]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../../static/assets/images/phone2.svg"),
      "alt": "phone"
    }
  }), _vm._v(" " + _vm._s(_vm.rental.phone) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../../static/assets/images/mail4.svg"),
      "alt": "email"
    }
  }), _vm._v("  " + _vm._s(_vm.rental.email) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-4"
  }, [_c('div', {
    staticClass: "info-right-side"
  }, [_c('div', {
    staticClass: "right-side-content"
  }, [_c('img', {
    class: !_vm.rental.photos || (_vm.rental.photos && !_vm.rental.photos.length) ? 'not-img' : '',
    attrs: {
      "src": (_vm.rental.photos && _vm.rental.photos.length > 0) ? _vm.rental.photos[0].name : '/static/assets/images/1585138900.jpg',
      "alt": "rental-image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-available"
  }, [_c('div', {
    staticClass: "right-side-info-part"
  }, [_c('p', {
    staticClass: "rental-name"
  }, [_vm._v("\n                    " + _vm._s(_vm.rental.name) + "\n                  ")]), _vm._v(" "), _c('p', {
    staticClass: "rental-address"
  }, [_vm._v("\n                    " + _vm._s(((_vm.rental.city) + " - " + (_vm.rental.address))) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rental-date"
  }, [_c('p', [_vm._v("\n                      " + _vm._s(((_vm.bookingDetail.checking) + " - " + (_vm.bookingDetail.checkout))) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('booking_engine.nbr_adults')) + " : " + _vm._s(_vm.bookingDetail.nbr_adults) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('booking_engine.nbr_children')) + " : " + _vm._s(_vm.bookingDetail.nbr_children) + "\n                    ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', [(_vm.bookingDetail.promoType) ? _c('div', {
    staticClass: "available-row"
  }, [_c('p', {
    staticClass: "available-text member-rate-text"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('booking.promo.discount')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "available-text member-rate-text"
  }, [_vm._v("\n                      " + _vm._s(("- " + (_vm.bookingDetail.amount) + " " + (_vm.bookingDetail.promoType === 'percent' ? '%' : _vm.rental.currency.symbol))) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "available-row"
  }, [_c('p', {
    staticClass: "available-text"
  }, [_vm._v("\n                      " + _vm._s((_vm.pricePerNight + " " + (_vm.rental.currency.symbol) + " × " + _vm.duration + " ")) + " " + _vm._s(_vm.$t('booking_engine.nights'))), (_vm.duration > 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "available-text"
  }, [_vm._v("\n                      " + _vm._s(((_vm.bookingDetail.initialPrice) + " " + (_vm.rental.currency.symbol))) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "available-row"
  }, [_c('p', {
    staticClass: "available-text"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('input.cleaning_fees')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "available-text"
  }, [_vm._v("\n                      " + _vm._s(((_vm.rental.cleaning) + " " + (_vm.rental.currency.symbol))) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "available-row"
  }, [_c('p', {
    staticClass: "available-text"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('input.city_taxes')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "available-text"
  }, [_vm._v("\n                      " + _vm._s(((_vm.parseAndRound(_vm.bookingDetail.city_taxes)) + " " + (_vm.rental.currency.symbol))) + "\n                    ")])]), _vm._v(" "), _c('hr', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "available-row"
  }, [_c('p', {
    staticClass: "available-text total-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('input.total')))])]), _vm._v(" "), _c('p', {
    staticClass: "available-text total-text"
  }, [_vm._v("\n                      " + _vm._s((((_vm.bookingDetail.initialPrice != null ? _vm.bookingDetail.initialPrice : _vm.bookingDetail.price) + _vm.rental.cleaning + _vm.bookingDetail.city_taxes) + " " + (_vm.rental.currency.symbol))) + "\n                    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rental.user_web.first_payment),
      expression: "rental.user_web.first_payment"
    }],
    staticClass: "available-row"
  }, [_c('p', {
    staticClass: "available-text first-payment-text"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('booking_engine.first_payment')) + "(" + _vm._s(((_vm.rental.user_web.percent) + "%")) + ")\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "available-text first-payment-text"
  }, [_vm._v("\n                      " + _vm._s(((_vm.getBookingPartPrice(_vm.bookingDetail.initialPrice != null ? _vm.bookingDetail.initialPrice : _vm.bookingDetail.price, _vm.rental.cleaning, _vm.bookingDetail.city_taxes, _vm.rental.user_web.percent)) + " " + (_vm.rental.currency.symbol))) + "\n                    ")])])])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e262ec"}!./src/app/pages/external-availability/confirmation.html
// module id = 1443
// module chunks = 0